import { put, select, takeLatest } from 'redux-saga/effects'
import { VitalsConstants } from '../store/vitals.constants'
import { getPatientVitalsSelector } from '../selectors/patientVitals.selector'
import { IPatientVitals } from '../store/vitals.types'
import { setMapVital } from '../store/vitals.actions'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { removeValidationError } from '../../../utilities/runRulesValidation.util'
import { getRulesSelector } from '../../rules/selectors'
import { IRulesState } from '../../rules/store/rules.types'

export function* setCalculatedMapVital() {
  const patientVital: IPatientVitals = yield select(getPatientVitalsSelector)
  const { diastolicBP, systolicBP, diastolicBPPNNV, systolicBPPNNV } = patientVital
  const rules: IRulesState = yield select(getRulesSelector)
  const { errors } = rules
  if (systolicBP && diastolicBP && diastolicBP !== 'P' && parseInt(systolicBP) <= 500 && parseInt(diastolicBP) <= 500) {
    removeValidationError(errors, VitalsConstants.SET_DIASTOLIC_BLOOD_PRESSURE, patientVital.key)
    removeValidationError(errors, VitalsConstants.SET_SYSTOLIC_BLOOD_PRESSURE, patientVital.key)
    const mapVital = Math.round(parseInt(systolicBP) / 3 + (parseInt(diastolicBP) * 2) / 3).toString()
    yield put(setMapVital(mapVital))
  }
  if (diastolicBPPNNV || systolicBPPNNV) {
    yield put(setMapVital(null))
  }
}

export function* setCalculatedMapVitalSaga() {
  yield takeLatest(
    [
      VitalsConstants.SET_SYSTOLIC_BLOOD_PRESSURE,
      VitalsConstants.SET_DIASTOLIC_BLOOD_PRESSURE,
      VitalsConstants.SET_SYSTOLIC_BLOOD_PRESSURE_PNNV,
      VitalsConstants.SET_DIASTOLIC_BLOOD_PRESSURE_PNNV,
    ],
    performWithMutexHOG,
    setCalculatedMapVital
  )
}
